// 設定モジュール翻訳 - 日本語
export default {
  title: '設定',
  subtitle: 'アプリ体験をパーソナライズ',
  
  // 設定グループ
  groups: {
    privacySecurity: 'プライバシーとセキュリティ',
    appSettings: 'アプリ設定',
    personalData: '個人データ',
    helpSupport: 'ヘルプとサポート'
  },
  
  // 設定項目
  items: {
    privacySettings: {
      title: 'プライバシー設定とポリシー',
      subtitle: 'AI機能、データ使用制御'
    },
    privacyCollection: {
      title: '個人情報収集',
      subtitle: 'データの使用方法を確認'
    },
    appSettings: {
      title: 'アプリ設定',
      subtitle: 'アプリの動作をカスタマイズ'
    },
    notificationSettings: {
      title: '通知設定',
      subtitle: 'プッシュ通知の設定を管理'
    },
    languageSettings: {
      title: '言語設定',
      subtitle: '使用言語を選択',
      sectionTitle: '言語を選択',
      sectionSubtitle: 'お好みの言語を選択してください',
      note: '言語変更は即座に反映され、アプリの再起動は不要です'
    },
    bodyDataSetup: {
      title: '身体データ設定',
      subtitle: '健康データパラメータを設定'
    },
    helpFeedback: {
      title: 'ヘルプとフィードバック',
      subtitle: 'ヘルプを受けるか提案を送信',
      appTitle: 'CubeMeet',
      appSlogan: '一緒にキューブ、より良い出会いを',
      appDescription: '複数の共同購入活動とインテリジェント機能をサポートする総合ソーシャルプラットフォーム。',
      coreFeatures: 'コア機能',
      contactSupport: 'サポートに連絡',
      emailFeedback: 'メールフィードバック',
      emailFeedbackDesc: 'メールを送信',
      features: {
        travel: {
          name: '旅行',
          desc: 'スマート旅行経費分担、AI領収書認識'
        },
        carpool: {
          name: 'カープール',
          desc: '環境に優しい移動、エコライドシェア'
        },
        dining: {
          name: '食事',
          desc: 'イベント集会と食事'
        },
        shopping: {
          name: 'ショッピング',
          desc: '中古取引、地域マーケットプレイス'
        },
        fitness: {
          name: 'フィットネス',
          desc: '体調管理、健康追跡'
        },
        todo: {
          name: 'Todo',
          desc: 'タスク管理、共同リスト'
        },
        ledger: {
          name: '家計簿',
          desc: '個人およびクラウド会計'
        },
        groupBuying: {
          name: 'グループ購入',
          desc: 'グループ注文、フードデリバリー共有'
        },
        toolbox: {
          name: 'ツールボックス',
          desc: 'AIスマートツール、インテリジェントレシピ'
        }
      }
    },
    dataExport: {
      title: 'データエクスポート',
      subtitle: '個人データをダウンロード'
    },
    deleteAccount: {
      title: 'アカウント削除',
      subtitle: 'アカウントとデータを完全に削除'
    }
  },
  
  // 通知
  notifications: {
    languageChanged: '言語が正常に変更されました',
    settingsSaved: '設定が保存されました',
    dataExported: 'データが正常にエクスポートされました',
    accountDeleted: 'アカウントが削除されました'
  },
  
  // 確認ダイアログ
  confirmations: {
    deleteAccount: {
      title: 'アカウント削除',
      message: 'この操作は元に戻すことができません。本当にアカウントを削除しますか？',
      confirm: '削除',
      cancel: 'キャンセル'
    },
    dataExport: {
      title: 'データエクスポート',
      message: '個人データをエクスポートしますか？',
      confirm: 'エクスポート',
      cancel: 'キャンセル'
    }
  },

  // プライバシー設定画面
  privacyScreen: {
    title: 'プライバシー設定とポリシー',
  infoTitle: 'プライバシー設定とポリシー',
  infoDescription: 'ここでAI機能、データ同期、プライバシー関連の設定を制御し、個人情報を保護できます。',
    privacyProtection: 'プライバシー保護',
    privacyDescription: '私たちはあなたのプライバシーを尊重し、あなたのデータの使用方法を完全にコントロールできます。これらの設定は、アプリがあなたの個人情報をどのように扱うかを決定します。',
    aiFeaturesControl: 'AI機能制御',
    aiPrivacyControl: 'AIプライバシー制御',
    aiPrivacySubtitle: 'アプリでのAI技術の使用を制御して、データプライバシーを保護',
    enableAiFeatures: 'AI機能を有効にする',
    aiFeatureDescription: 'テキスト認識、食品認識、スマート推奨などのAI機能を含む',
    dataUsageSecurity: 'データ使用セキュリティ',
    dataPrivacyControl: 'データプライバシー制御',
    dataPrivacySubtitle: 'データのクラウドストレージと共有を制御して、プライバシーセキュリティを確保',
    cloudDataSharing: 'クラウドデータ共有',
    cloudSharingDescription: '共有家計簿の作成を許可し、他のユーザーとの協力のためにデータをクラウドに同期',
    dataUsageExplanation: 'データ使用説明',
    dataUsagePoint1: 'AI処理されたデータは、対応する機能を提供するためにのみ使用されます',
    dataUsagePoint2: 'データ転送は暗号化保護を使用します',
    dataUsagePoint3: 'あなたの個人プライバシー情報を保存しません',
    dataUsagePoint4: 'いつでも任意の機能を無効にできます',
    privacyPolicyAndTerms: 'プライバシーポリシーと利用規約',
    privacyPolicy: 'プライバシーポリシー',
    termsOfService: '利用規約',
    futurePrivacySettings: 'その他のプライバシー設定',
    futurePrivacyDescription: '将来のバージョンでは、共有家計簿、データ同期などのより多くのプライバシー制御オプションが追加されます。'
  },

  // プライバシーポリシー画面
  privacyPolicyScreen: {
    title: 'プライバシーポリシー',
    dataCollection: 'データ収集',
    dataCollectionContent: '私たちはあなたのプライバシーと個人情報のセキュリティを保護することをお約束します。このアプリが収集する情報は、より良いサービス体験を提供するためにのみ使用され、他の商業目的には使用されません。',
    informationUse: '情報の使用',
    informationUseContent: '• あなたの個人情報は、アプリ機能の正常な運用にのみ使用されます\n• 第三者にあなたの個人情報を販売または共有することはありません\n• すべてのデータ転送は暗号化されています',
    dataSecurity: 'データセキュリティ',
    dataSecurityContent: 'データ暗号化、セキュア転送プロトコルなど、業界標準のセキュリティ対策を採用してあなたの個人情報を保護しています。',
    userRights: 'ユーザーの権利',
    userRightsContent: 'あなたはいつでも以下の権利を有します：\n• 私たちが収集したあなたに関する情報を確認する\n• あなたの個人情報の修正または削除を要求する\n• データ処理への同意を撤回する\n• いつでも機能を無効にするかアカウントを削除する',
    contactUs: 'お問い合わせ',
    contactUsContent: 'このプライバシーポリシーについてご質問がございましたら、お問い合わせください：\nメール: privacy@cubemeet.com',
    lastUpdated: '最終更新日: 2025年1月1日'
  },

  // 利用規約画面
  termsOfServiceScreen: {
    title: '利用規約',
    acceptanceOfTerms: '規約の同意',
    acceptanceContent: 'このアプリを使用することにより、以下の利用規約に従うことに同意したものとみなされます。これらの規約に同意しない場合は、このアプリを使用しないでください。',
    serviceDescription: 'サービス説明',
    serviceDescriptionContent: 'CubeMeetは、ユーザーが以下のことを行うのを支援するソーシャルライフアプリです：\n• 個人および共有家計簿の管理\n• 旅行、食事、カープールなどのグループ活動の企画\n• 友達との生活の瞬間を共有\n• AIスマート機能を使用して体験を向上',
    userResponsibilities: 'ユーザーの責任',
    userResponsibilitiesContent: 'このアプリを使用する際、あなたは以下に同意します：\n• 正確で真実の情報を提供する\n• 法律および規制に違反しない\n• 他者の権利を侵害しない\n• 悪意のある行為やサービスの濫用を行わない',
    serviceLimitations: 'サービスの制限',
    serviceLimitationsContent: '以下の状況において、サービスを制限または終了する権利を留保します：\n• 利用規約の違反\n• 技術的メンテナンスの要件\n• 法的および規制上の要件\n• その他の合理的な理由',
    disclaimer: '免責事項',
    disclaimerContent: 'このアプリは「現状のまま」サービスを提供し、以下について責任を負いません：\n• サービスの中断またはデータの損失\n• 第三者サービスの問題\n• ユーザー間の紛争\n• 不可抗力要因',
    termsModification: '規約の変更',
    termsModificationContent: 'いつでもこれらの規約を変更する権利を留保します。重要な変更については、アプリ内通知を通じてユーザーに通知されます。アプリの継続使用は、変更された規約への同意を示します。',
    contactUs: 'お問い合わせ',
    contactUsContent: 'これらの利用規約について質問がある場合は、お問い合わせください：\nメール: my.cubemeet@gmail.com',
    contactInfo: 'お問い合わせ情報',
    contactInfoContent: 'ご質問やサポートが必要な場合は、お問い合わせください：\nメール: support@cubemeet.com',
    lastUpdated: '最終更新日: 2025年1月1日'
  }
};
